/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BackgroundCheckCard_delegate = {
    readonly uuid: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: string | null;
    readonly profileImageUrl: string | null;
    readonly backgroundCheckPending: boolean;
    readonly hasActiveBackgroundCheck: boolean;
    readonly pendingBackgroundCheck: {
        readonly approvalDate: string | null;
        readonly applicationSentAt: string | null;
        readonly applicationReceivedAt: string | null;
        readonly hasAllResponses: boolean;
        readonly requestedDBS: boolean;
        readonly isRenewal: boolean;
        readonly isVerification: boolean;
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
        readonly onlyDBS: boolean;
    } | null;
    readonly currentBackgroundCheck: {
        readonly approvalDate: string | null;
        readonly expiresAt: string | null;
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
        readonly isVerification: boolean;
        readonly isCAA: boolean;
        readonly onlyDBS: boolean;
    } | null;
    readonly " $refType": "BackgroundCheckCard_delegate";
};
export type BackgroundCheckCard_delegate$data = BackgroundCheckCard_delegate;
export type BackgroundCheckCard_delegate$key = {
    readonly " $data"?: BackgroundCheckCard_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"BackgroundCheckCard_delegate">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "approvalDate",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isVerification",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "idExpiryDate",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "dbsExpiryDate",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "onlyDBS",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "BackgroundCheckCard_delegate",
        "type": "Delegate",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "uuid",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "firstName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "lastName",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "profileImageUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "backgroundCheckPending",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasActiveBackgroundCheck",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pendingBackgroundCheck",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "applicationSentAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "applicationReceivedAt",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasAllResponses",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "requestedDBS",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isRenewal",
                        "args": null,
                        "storageKey": null
                    },
                    (v1 /*: any*/),
                    (v2 /*: any*/),
                    (v3 /*: any*/),
                    (v4 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "currentBackgroundCheck",
                "storageKey": null,
                "args": null,
                "concreteType": "BackgroundCheck",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "expiresAt",
                        "args": null,
                        "storageKey": null
                    },
                    (v2 /*: any*/),
                    (v3 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isCAA",
                        "args": null,
                        "storageKey": null
                    },
                    (v4 /*: any*/)
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '2fc699987f7382d58dac04d9bf272fce';
export default node;
